import { render, staticRenderFns } from "./QuotationsAddressed.vue?vue&type=template&id=0a9859bf&"
import script from "./QuotationsAddressed.vue?vue&type=script&lang=js&"
export * from "./QuotationsAddressed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports